import { boolean, number, string, struct } from 'io-ts/lib/Decoder';

import { Point } from '../../../ui/geometry/Point';

/**
 * A dimension line used for scale calibration and verification in HITL.
 */
export const DimensionLine = struct({
	id: string,
	start: Point,
	end: Point,
	/** mm or inches, taken from OCR-linked text. */
	metricLength: number,
	verified: boolean,
	/** mm or inches, calculated from pixel length and page scale. */
	calculatedLength: number,
});
